// extracted by css-extract-rspack-plugin
export default {"codeContainer":"QJiGE"};